import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const editorialTeamProofApi = generateProofApi('/proof-file/editorial-team');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('editorial-team', editorialTeamProofApi);

export function getEditorialTeamProofsByOwnerOptions(
  editorialTeamId: Id,
  userId: Id,
): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(editorialTeamId, userId);
}

export function getEditorialTeamProofsOptions(editorialTeamId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(editorialTeamId);
}

export function useUploadOrUpdateEditorialTeamProof(editorialTeamId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(editorialTeamId, queryClient));
}

export function useDeleteEditorialTeamProof(editorialTeamId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(editorialTeamId, queryClient));
}
